import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import * as moment from "moment";
import { Table } from "primeng/table";
import { ConversaoLibraConverte } from "../../../shared/conversao-libra/conversao-libra-converte";
import { ExportExcelService } from "../../../shared/excel-service/export-excel.service";
import { FiltroDealers } from "./filtro-dealer";
import { RelatorioOportunidadeFiltroService } from "./relatorio-oportunidade-filtro.service";
import { RelatorioOportunidadeService } from "./relatorio-oportunidade.service";

declare var $: any;

@Component({
  selector: "app-relatorio-oportunidade",
  templateUrl: "./relatorio-oportunidade.component.html",
  styleUrls: ["./relatorio-oportunidade.component.scss"],
})
export class RelatorioOportunidadeComponent implements OnInit {
  @Input() filtros: any;

  form: FormGroup;
  subscription: any;
  selecionado: object;
  selecionados = [];
  cols: any[];
  _selectedColumns: any[];
  relatorioOportunidadeDados: any[] = [];
  numero_nfe: any;
  serie: any;
  id_dealer: any;
  first = 0;
  displayRows: number = 0;
  rows = 20;
  totalRecords = 0;
  loading: boolean = false;
  displayFiltros: boolean = false;
  displayFiltrosDealers: boolean = false;
  nomeModulo: string;
  dataInicial: Date;
  dataFinal: Date;
  maxDate: Date = new Date();
  filtrosDealers: FiltroDealers;
  display: boolean = false;
  cargaTela: boolean;

  @ViewChild("dt") dt: Table;

  dadosTranslate = {
    "businessIntelligence.relatorioOportunidade.chassiCompleto":
      this.translate.instant(
        "businessIntelligence.relatorioOportunidade.chassiCompleto"
      ),
    "businessIntelligence.relatorioOportunidade.dataCriacao":
      this.translate.instant(
        "businessIntelligence.relatorioOportunidade.dataCriacao"
      ),
    "businessIntelligence.relatorioOportunidade.ultimaOs":
      this.translate.instant(
        "businessIntelligence.relatorioOportunidade.ultimaOs"
      ),
    "businessIntelligence.relatorioOportunidade.dealer": this.translate.instant(
      "businessIntelligence.relatorioOportunidade.dealer"
    ),
    "businessIntelligence.relatorioOportunidade.planoManutencao":
      this.translate.instant(
        "businessIntelligence.relatorioOportunidade.planoManutencao"
      ),
    "businessIntelligence.relatorioOportunidade.primeiraRevisao":
      this.translate.instant(
        "businessIntelligence.relatorioOportunidade.primeiraRevisao"
      ),
    "businessIntelligence.relatorioOportunidade.segundaRevisao":
      this.translate.instant(
        "businessIntelligence.relatorioOportunidade.segundaRevisao"
      ),
    "businessIntelligence.relatorioOportunidade.terceiraRevisao":
      this.translate.instant(
        "businessIntelligence.relatorioOportunidade.terceiraRevisao"
      ),
    "businessIntelligence.relatorioOportunidade.quartaRevisao":
      this.translate.instant(
        "businessIntelligence.relatorioOportunidade.quartaRevisao"
      ),
    "businessIntelligence.relatorioOportunidade.quintaRevisao":
      this.translate.instant(
        "businessIntelligence.relatorioOportunidade.quintaRevisao"
      ),
  };

  constructor(
    private service: RelatorioOportunidadeService,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private servico: RelatorioOportunidadeFiltroService,
    private exportExcelService: ExportExcelService,
    private fb: FormBuilder
  ) {
    this.filtros = {};
    this.nomeModulo = "relatorio-oportunidade";
    this.filtrosDealers = new FiltroDealers(this.servico);
    this.tratarData();

    this.form = this.fb.group({
      data_inicial: [moment(this.dataInicial).format("DD-MM-YYYY")],
      data_final: [moment(this.dataFinal).format("DD-MM-YYYY")],
      dealers: [""],
    });

    this.maxDate.setDate(this.maxDate.getDate());
  }

  ngOnInit() {
    this.cargaTela = true;
    this.changeLanguageValue();
    // this.preencherOrigem();

    this.cols = [
      {
        field: "dealer",
        header: "businessIntelligence.relatorioOportunidade.dealer",
        headerBr: "Dealer",
        headerGb: "Dealer",
      },
      {
        field: "chassi_completo",
        header: "businessIntelligence.relatorioOportunidade.chassiCompleto",
        headerBr: "Chassi",
        headerGb: "Chassis",
      },
      {
        field: "data_criacao",
        header: "businessIntelligence.relatorioOportunidade.dataCriacao",
        headerBr: "Data Criação",
        headerGb: "Created At",
      },
      // Ultima O.S. do veiculo, no formato DATA / DEALER / TIPO FABRICA.
      // A informacao vem do historico do chassi e nao herda o filtro de
      // dealer da tela: mesmo consultando um dealer especifico, a coluna
      // mostra a ultima passagem onde quer que ela tenha acontecido.
      {
        field: "ultima_os",
        header: "businessIntelligence.relatorioOportunidade.ultimaOs",
        headerBr: "Última O.S.",
        headerGb: "Last Work Order",
      },
      {
        field: "plano_manutencao",
        header: "businessIntelligence.relatorioOportunidade.planoManutencao",
        headerBr: "Plano Manutenção",
        headerGb: "Maintenance Plan",
      },
      {
        field: "primeira_revisao",
        header: "businessIntelligence.relatorioOportunidade.primeiraRevisao",
        headerBr: "1ª Revisão",
        headerGb: "1st Review",
      },
      {
        field: "segunda_revisao",
        header: "businessIntelligence.relatorioOportunidade.segundaRevisao",
        headerBr: "2ª Revisão",
        headerGb: "2nd Review",
      },
      {
        field: "terceira_revisao",
        header: "businessIntelligence.relatorioOportunidade.terceiraRevisao",
        headerBr: "3ª Revisão",
        headerGb: "3nd Review",
      },
      {
        field: "quarta_revisao",
        header: "businessIntelligence.relatorioOportunidade.quartaRevisao",
        headerBr: "4ª Revisão",
        headerGb: "4nd Review",
      },
      {
        field: "quinta_revisao",
        header: "businessIntelligence.relatorioOportunidade.quintaRevisao",
        headerBr: "5ª Revisão",
        headerGb: "5nd Review",
      },
    ];

    this._selectedColumns = this.cols;

    this.filtrosDealers.carregar();
    this.getAll();
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    this._selectedColumns = this.cols.filter((col) => val.includes(col));
  }

  get f() {
    return this.form.controls;
  }

  filtroAtivo = "relatorio";

  alterarFiltro(filtro: "todos" | "comPlanoManutencao" | "semPlanoManutencao") {
    this.filtroAtivo = filtro;
    this.first = 0;
    this.getAll();
  }

  private getAll() {
    this.loading = true;

    let status;

    switch (this.filtroAtivo) {
      case "comPlanoManutencao": // com plano de manutenção
        status = true;
        break;

      case "semPlanoManutencao": // sem plano de manutenção
        status = false;
        break;

      case "todos": // todos
      default:
        // não envia nada → backend retorna tudo
        break;
    }

    this.service
      .getDados(
        this.f.data_inicial.value,
        this.f.data_final.value,
        this.f.dealers.value,
        status
      )
      .subscribe((response) => {
        this.relatorioOportunidadeDados = response.dados ?? [];
        this._selectedColumns = this.cols;

        this.loading = false;
        this.cargaTela = false;
      });
  }

  private orderByDate() {
    this.relatorioOportunidadeDados.sort((a, b) => {
      let data_a = a.data;
      let data_b = b.data;

      if (data_a > data_b) return -1;
      if (data_a < data_b) return 1;

      return 0;
    });
  }

  private tratarData() {
    const dataInicio = new Date();
    const dataFim = new Date();

    let firstDay = new Date(dataInicio.getFullYear(), dataInicio.getMonth(), 1);

    this.dataInicial = firstDay;
    this.dataFinal = dataFim;
  }

  public filtroAPI() {
    this.displayFiltros = false;

    this.f.data_inicial.setValue(moment(this.dataInicial).format("DD-MM-YYYY"));
    this.f.data_final.setValue(moment(this.dataFinal).format("DD-MM-YYYY"));

    this.filtrosSelecionados();
    this.getAll();
  }

  private filtrosSelecionados() {
    const dealers = [];

    this.incluirFiltroDealers(dealers);

    this.filtros.dealers = dealers.map((r) => r.valor);

    if (this.filtros.dealers.length != 0) {
      this.f.dealers.setValue(this.filtros.dealers[0]);
    } else {
      this.f.dealers.setValue("");
    }
  }

  public getListagemComFiltros(): boolean {
    return (
      this.dataInicial ||
      this.dataFinal ||
      this.f.partNumber.value ||
      this.f.numeroOs.value ||
      this.f.numeroChassi.value ||
      this.f.tipo.value
    );
  }

  public selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  public removerDealer(dealer: any) {
    dealer.selecionado = false;
    const index = this.filtros.dealers;
    if (index > -1) {
      this.filtros.dealers.splice(index, dealer);
      this.filtrosSelecionados();
    }
  }

  public onAdicionarDealerFiltro(dealer: any) {
    dealer.selecionado = true;
    const sel = [];

    this.incluirFiltroDealers(sel);
    this.filtros.dealers = sel;
  }

  public exibirFiltro() {
    this.displayFiltros = true;
  }

  private incluirFiltroDealers(filtros: any[]) {
    if (this.filtrosDealers.selecionados().length > 0) {
      const item = { chave: "dealers", valor: [] };
      this.filtrosDealers.selecionados().forEach((element) => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  public limparFiltros() {
    this.f.partNumber.setValue("");
    this.f.numeroOs.setValue("");
    this.f.numeroChassi.setValue("");
    this.f.tipo.setValue("");
  }

  public limpaDataInicial() {
    const dataInicio = new Date();
    this.dataInicial = new Date(
      dataInicio.getUTCFullYear(),
      dataInicio.getMonth(),
      1
    );
  }

  public limpaDataFinal() {
    const dataFim = new Date();
    this.dataFinal = new Date(
      dataFim.getFullYear(),
      dataFim.getMonth(),
      dataFim.getDate()
    );
  }

  protected getTranslate(value) {
    return this.dadosTranslate[value];
  }

  private translateHeader(item: string): string {
    const col = this.cols?.find((c) => c.header === item);
    if (col) {
      return this.translate.currentLang === "br" ? col.headerBr : col.headerGb;
    }
    return item;
  }

  private translateField(item: any): any {
    if (item === null || item === undefined) {
      return "";
    }
    return item;
  }

  public exportExcel(): void {
    if (!this.relatorioOportunidadeDados || this.relatorioOportunidadeDados.length === 0) {
      return;
    }

    this.exportExcelService.nomeModulo =
      this.translate.currentLang === "br"
        ? "Relatório de Oportunidades"
        : "Opportunity Report";

    this.exportExcelService.ExportTOExcelJSON(
      this.relatorioOportunidadeDados.map((r) => {
        let linha = {};

        this._selectedColumns.forEach((c) => {
          linha[this.translateHeader(c.header)] = this.translateField(
            r[c.field]
          );
        });

        return linha;
      })
    );
  }

  private changeLanguageValue() {
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.getAll();
      }
    );
  }
}